import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-swap-horizontal-sharp",
  "use": "icon-swap-horizontal-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-swap-horizontal-sharp\"><title>Swap Horizontal</title><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"32\" d=\"M304 48l112 112-112 112M398.87 160H96M208 464L96 352l112-112M114 352h302\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol